"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractModel = void 0;
var abstract_model_light_1 = require("./abstract-model-light");
// tslint:disable-next-line
var nanoid = require('nanoid');
/**
 * Any model that wishes to be represented into a document goes here
 */
var AbstractModel = /** @class */ (function (_super) {
    __extends(AbstractModel, _super);
    function AbstractModel(properties) {
        var _this = _super.call(this, properties) || this;
        _this.onUpdate = function () {
        };
        return _this;
    }
    /**
     * Assigns default base properties
     * @param {boolean} override - if true, does not assign a ID
     * @param {string} id - the id to override with otherwise will use a random id, only used when override is true
     * @return {AbstractSchema}
     */
    AbstractModel.defaultBaseProps = function (override, id) {
        if (override === void 0) { override = false; }
        var props = {};
        var key = 'id';
        // If override = true, do not assign a ID unless id is provided
        // if override = false, assign a ID either random or provided
        if (!override) {
            props[key] = id ? id : nanoid();
        }
        else if (override && id) {
            props[key] = id;
        }
        return props;
    };
    AbstractModel.randomId = function (size) {
        if (size === void 0) { size = 21; }
        return nanoid(size);
    };
    Object.defineProperty(AbstractModel.prototype, "id", {
        get: function () {
            return this.props.id;
        },
        enumerable: false,
        configurable: true
    });
    AbstractModel.prototype.set = function (props) {
        _super.prototype.set.call(this, props);
        this.onUpdate(this.props);
    };
    return AbstractModel;
}(abstract_model_light_1.AbstractModelLight));
exports.AbstractModel = AbstractModel;
